import { useState } from "react"
import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { cn } from "../lib/utils"

export function ToggleGroupRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent } = useRenderContext()
  const [selectedId, setSelectedId] = useState<string | null>(null)

  const items = element.children ?? []

  return (
    <div
      className={cn(
        "inline-flex items-center gap-1 rounded-md border border-border bg-background p-1",
        element.className
      )}
      data-testid={`toggle-group-${element.id}`}
      role="group"
      aria-label={element.ariaLabel ?? "Toggle group"}
    >
      {items.map((item) => {
        const label = item.text ? String(resolveSymbol(item.text) ?? "") : item.id
        const isSelected = selectedId === item.id

        return (
          <button
            key={item.id}
            type="button"
            className={cn(
              "inline-flex items-center justify-center rounded-sm px-3 py-1.5 text-sm font-medium transition-colors",
              isSelected
                ? "bg-accent text-accent-foreground shadow-sm"
                : "text-foreground hover:bg-muted hover:text-muted-foreground"
            )}
            onClick={() => {
              setSelectedId(item.id)
              dispatchEvent(item.id, "tap", {
                value: item.text ?? item.id,
                selected: true,
              })
            }}
            aria-pressed={isSelected}
            aria-label={item.ariaLabel ?? label}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}
